import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-50 border-t border-background-300/30">
      <div className="container-main py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-movie-2-line text-background-950 text-lg"></i>
              </div>
              <span className="text-lg font-bold text-foreground-50">鲁鲁影院</span>
            </div>
            <p className="text-sm text-foreground-500 leading-relaxed">
              高清免费在线不缓冲，每日更新最新电影和热播电视剧。海量资源、流畅播放、完全免费，畅享追剧体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4">
              <a href="#quick-links" className="hover:text-primary-400 transition-colors">快速链接</a>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors">首页</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors">关于我们</Link>
              </li>
              <li>
                <Link to="/category/all" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors">全部影片</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4">
              <a href="#categories" className="hover:text-primary-400 transition-colors">热门分类</a>
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(1, 7).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-500 hover:text-primary-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4">
              <a href="#contact" className="hover:text-primary-400 transition-colors">联系我们</a>
            </h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-500">
                <i className="ri-mail-line text-primary-500 w-4 h-4 flex items-center justify-center"></i>
                support@lulucinema.com
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-500">
                <i className="ri-wechat-line text-primary-500 w-4 h-4 flex items-center justify-center"></i>
                鲁鲁影院官方
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-300/20 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-600">
            &copy; {currentYear} 鲁鲁影院. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="https://weibo.com" target="_blank" rel="nofollow noopener noreferrer" className="text-foreground-500 hover:text-primary-400 transition-colors" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="https://weixin.qq.com" target="_blank" rel="nofollow noopener noreferrer" className="text-foreground-500 hover:text-primary-400 transition-colors" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}